import { createFileRoute } from "@tanstack/react-router";
import { PillarPage, buildPillarHead } from "@/components/site/PillarPage";
import { PILLAR_BY_SLUG } from "@/lib/pillars";

const pillar = PILLAR_BY_SLUG["technology-tools"];

const faqs = [
  {
    q: "What's in the KCN technology stack?",
    a: "Brivity CRM and Dialer, Callfire, Google Suite, Zoom, Slydial, and the proprietary KCN Intranet and KCN Rewards App - plus the training and SOPs to actually use them in production.",
  },
  {
    q: "Do I have to use your tools, or can I bring my own stack?",
    a: "The KCN stack is what the playbook is built on, so you'll run the core systems we provide. That's how leverage compounds: shared CRM, shared scripts, shared dashboards. Your existing tools can sit alongside it where they make sense.",
  },
  {
    q: "What's the KCN Intranet?",
    a: "It's our internal knowledge base - playbooks, scripts, training, SOPs, and announcements in one place so agents and admin teams move at the same speed. It's a big reason new hires onboard fast inside KCN.",
  },
  {
    q: "What's the KCN Rewards App?",
    a: "A proprietary rewards platform that recognizes agent activity and milestones across the network. It's part of why KCN culture stays high-momentum without resorting to brokerage politics.",
  },
];

export const Route = createFileRoute("/technology-and-tools")({
  head: () => buildPillarHead(pillar, faqs),
  component: () => (
    <PillarPage
      pillar={pillar}
      intro="Tools alone don't make agents productive - adopted tools do. KCN invests in industry-leading platforms and trains every agent to run them like an operator, so technology becomes leverage instead of overhead."
      sections={[
        {
          eyebrow: "The agent toolbox",
          heading: "Best-in-class platforms. One playbook.",
          body: "KCN agents have full access to a vetted suite of platforms - selected because they actually move the needle on contact, conversion, and follow-through. We pair each tool with a documented workflow so adoption isn't optional and results aren't accidental.",
          bullets: [
            "Brivity CRM & Dialer - pipeline, follow-up, and IDX",
            "Callfire - outbound calling and SMS",
            "Google Suite - collaboration, docs, drive",
            "Zoom - coaching, training, virtual closings",
            "Slydial - ringless voicemail at scale",
            "KCN Rewards App - proprietary recognition platform",
            "KCN Intranet - proprietary playbooks and SOPs",
          ],
        },
        {
          eyebrow: "Proprietary tech",
          heading: "Tools we built because nothing else fit.",
          body: "The KCN Intranet centralizes the entire playbook - scripts, training, SOPs, announcements - in one place agents and admins both live in. The KCN Rewards App keeps team momentum visible and celebrated across markets. These aren't off-the-shelf; they're competitive advantages.",
        },
      ]}
      benefits={{
        heading: "What the stack actually does for you.",
        items: [
          "Industry-leading CRM with dialer included",
          "Proprietary intranet for instant onboarding",
          "Rewards app that compounds team culture",
          "Documented SOP for every tool",
          "Vetted, integrated stack - no DIY assembly",
          "Training included, not sold separately",
        ],
      }}
      faqs={faqs}
    />
  ),
});
